<template lang="pug" src="./navigation-desktop.pug"></template>

<script>
import Icon from 'components/icon/icon'
import { showModal } from 'components/mixins'

export default {
  props: ['props', 'links'],
  data () {
    return {
      active: false,
      menu: 'menu'
    }
  },
  methods: {
    menuChange () {
      this.active = !this.active
      this.menu === 'menu' ? this.menu = 'close' : this.menu = 'menu'
      this.active ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    menuSelect () {
      this.active = false
      this.menu = 'menu'
      document.body.classList.remove('body-stop')
    }
  },
  computed: {
    classObject () {
      return {
        'navigation-desktop--white': this.$route.meta === true,
        'navigation-desktop--scrolled': this.$store.state.nav
      }
    }
  },
  mixins: [showModal],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// navigation-desktop.vue?73a3629a